import clsx from 'clsx';
import invariant from 'tiny-invariant';
import { Text } from '../Text/Text';

const DEFAULT_TOTAL_STEPS = 5;
const DEFAULT_ARIA_LABEL = 'Progress bar';

export type SegmentedProgressBarProps = {
  step: number;
  totalSteps?: number;
  'aria-label'?: string;
};

export const SegmentedProgressBar = ({
  step,
  totalSteps = DEFAULT_TOTAL_STEPS,
  'aria-label': ariaLabel = DEFAULT_ARIA_LABEL,
}: SegmentedProgressBarProps) => {
  invariant(
    step >= 0 && step <= totalSteps,
    'The step prop must be between 0 and totalSteps (inclusive)',
  );

  return (
    <div className="flex items-center gap-xs">
      <div
        className="flex flex-auto gap-xxs"
        role="progressbar"
        aria-label={ariaLabel}
        aria-valuenow={step}
        aria-valuemin={0}
        aria-valuemax={totalSteps}
      >
        {Array.from({ length: totalSteps }).map((_, idx) => (
          <div
            // eslint-disable-next-line react-x/no-array-index-key -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
            key={idx}
            className={clsx(
              'h-[8px] flex-1',
              idx < step ? 'bg-positive' : 'bg-accent-subtle',
              'rounded-sm',
            )}
          />
        ))}
      </div>
      <Text size="bodyS" color="contentSubdued">
        {step}/{totalSteps}
      </Text>
    </div>
  );
};
